import React from "react";
import AccountingUserListItem from "../../components/accountingUser/AccountingUserList/AccountingUserListItem";
import {Box} from "@mui/material";
import {useParams} from "react-router";
import {useTitle} from 'react-use';
import { t } from "@lingui/core/macro";

const AccountingUserListPage = ()  => {

    useTitle(t`List Accounting User`);
    
    const allQueries = useParams()
    const query = Object.fromEntries(
        Object.entries(allQueries).filter(([key]) => key.endsWith("Id"))
    )
    
    return (
        <Box>
            <AccountingUserListItem showAdd={true} {...query} />
        </Box>
    )
}

export default AccountingUserListPage;
